var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h6", {}, [
      _vm._v(_vm._s(_vm.$t(`${_vm.configId}.notifications.title`))),
    ]),
    _vm._v(" "),
    _c("hr", { staticClass: "mt-2" }),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-4" },
        [
          _c(
            "MaterialSelect",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
              ],
              staticClass: "city-form-group city-bg",
              attrs: {
                disabled: _vm.disabled,
                id: "input-notifications",
                name: "notifications",
                label: "name",
                filterable: true,
                options: _vm.lists.onoff,
                reduce: (option) => option.code,
                "data-vv-scope": _vm.vScope,
                inputClasses: [
                  { "is-invalid": _vm.fnHasError("notifications", _vm.vScope) },
                ],
                error: _vm.fnFirstError("notifications", _vm.vScope),
                helpText: _vm.helpNotifications.status,
              },
              model: {
                value: _vm.form.status,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.form,
                    "status",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "form.status",
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t(`${_vm.configId}.notifications.model.status`)) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }